import { type InternalIndexedDBDatabase } from "../../DataStores/Database";
import IndexedDBClassificationRepository from "../Classifications/IndexedDBClassificationRepository";

export default class IndexedDBFamilyRepository extends IndexedDBClassificationRepository {
    public readonly source: InternalIndexedDBDatabase["families"];
    protected readonly dataTypeName = "Family";

    constructor(source: InternalIndexedDBDatabase) {
        super();

        this.source = source.families;
    }
}
